import { t } from '@base/utils/helpers';
import React from 'react';
import { container } from 'tsyringe';
import GameMenuButtons from './gameMenuButtons';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import Codes from '@base/features/socket/codes';
import { BaseGameState } from '@base/features/game/model/interfaces';
import { useAsyncData } from '@utils/hooks';
import { IUserService } from '@base/features/user/model/interfaces';
import { useHistory } from 'react-router-dom';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { Loader } from '@ui-kit/components/loader';
import styles from '../styles/emailGame.module.scss';

export default function EmailGame(props: { closeModal: () => void; gameState: BaseGameState }) {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const userService: IUserService = container.resolve('userService');
  const history = useHistory();
  const { data: personalInfo } = useAsyncData(() => userService.getUserInfo());

  const sendEmailButtons = [
    {
      title: t('send'),
      onClick: () => {
        handleSend();
        props.closeModal();
      },
    },
    {
      title: t('cancel'),
      onClick: () => props.closeModal(),
    },
  ];

  const verifyEmailButtons = [
    {
      title: 'Complete registration',
      onClick: () => history.push(MAIN_ROUTES.completeRegistration),
    },
  ];

  const handleSend = () => {
    const tid = playersOnlineRepository.me?.getTable()?.tid;
    const pid = playersOnlineRepository.me?.getPid();

    if (tid !== undefined && pid !== undefined) {
      props.gameState.opponentIdleActionsDialog.sendService(Codes.ServiceTypes.EMAIL, pid, tid);
    }
  };

  return personalInfo ? (
    <>
      <h3>{t(personalInfo.email_verified ? 'email_game' : 'no_email')}</h3>
      <GameMenuButtons buttons={personalInfo.email_verified ? sendEmailButtons : verifyEmailButtons} />
    </>
  ) : (
    <div className={styles.loader}>
      <Loader width={100} height={100} />
    </div>
  );
}
